import { render, staticRenderFns } from "./radioBoxImg.vue?vue&type=template&id=27b8e089&scoped=true&"
import script from "./radioBoxImg.vue?vue&type=script&lang=js&"
export * from "./radioBoxImg.vue?vue&type=script&lang=js&"
import style0 from "./radioBoxImg.vue?vue&type=style&index=0&id=27b8e089&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b8e089",
  null
  
)

export default component.exports